import { render, staticRenderFns } from "./SupportTicket.vue?vue&type=template&id=f4714a20&"
import script from "./SupportTicket.vue?vue&type=script&lang=js&"
export * from "./SupportTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports